module.exports = __webpack_public_path__ + "img/main2-2.b3ae00dc.png";